import { render, staticRenderFns } from "./InviteUsersLimitModal.vue?vue&type=template&id=63045d17&"
import script from "./InviteUsersLimitModal.vue?vue&type=script&lang=js&"
export * from "./InviteUsersLimitModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports